import React, { useState } from 'react'
import AmbulanceBookingTabs from '../components/ambulance/AmbulanceBookingTabs'
import AmbulanceTypes from '../components/ambulance/AmbulanceTypes'
import EmergencyContacts from '../components/ambulance/EmergencyContacts'
const AmbulanceDemo = () => {
  const [selectedAmbulanceType, setSelectedAmbulanceType] = useState('bls')
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState(null)
  // Mock emergency contacts data
  const contacts = [
    { id: 1, name: 'Emergency Services', phone: '108', type: 'emergency' },
    { id: 2, name: 'Police', phone: '100', type: 'police' },
    { id: 3, name: 'Fire Department', phone: '101', type: 'fire' },
    { id: 4, name: 'Hospital Contact', phone: '+91 9876543210', type: 'hospital' }
  ]
  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <div className="bg-white border-b border-gray-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <div className="flex items-center justify-between">
            <div>
              <h1 className="text-2xl font-bold text-gray-900">Ambulance Booking Demo</h1>
              <p className="text-gray-600 mt-1">
                Test the ambulance booking system with live tracking and real-time updates
              </p>
            </div>
            <div className="flex items-center space-x-4">
              <div className="text-sm text-gray-500">
                Status: <span className="text-green-600 font-medium">Online</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Main Content */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {/* Demo Information */}
        <div className="mb-8">
          <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-6">
            <h2 className="text-lg font-semibold text-blue-900 mb-2">🚀 Demo Features</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-sm text-blue-800">
              <div>
                <p>✅ Real-time ambulance booking</p>
                <p>✅ Live tracking with WebSocket</p>
                <p>✅ Status updates and notifications</p>
              </div>
              <div>
                <p>✅ Emergency priority handling</p>
                <p>✅ Driver assignment and management</p>
                <p>✅ Complete booking history</p>
              </div>
            </div>
          </div>
          {/* Quick Info Cards */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
            <div className="bg-white p-4 rounded-lg border border-gray-200">
              <h3 className="font-medium text-gray-900 mb-2">🚑 Ambulance Types</h3>
              <p className="text-sm text-gray-600">BLS, ALS, and Critical Care available</p>
            </div>
            <div className="bg-white p-4 rounded-lg border border-gray-200">
              <h3 className="font-medium text-gray-900 mb-2">📍 Live Tracking</h3>
              <p className="text-sm text-gray-600">Real-time location updates via WebSocket</p>
            </div>
            <div className="bg-white p-4 rounded-lg border border-gray-200">
              <h3 className="font-medium text-gray-900 mb-2">📞 Emergency Contacts</h3>
              <p className="text-sm text-gray-600">Clickable emergency contact information</p>
            </div>
          </div>
        </div>
        {/* Main Content */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 lg:gap-8">
          {/* Left Section - Booking Form */}
          <div className="lg:col-span-2">
            <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-4 sm:p-6">
              <AmbulanceBookingTabs 
                selectedAmbulanceType={selectedAmbulanceType}
                setSelectedAmbulanceType={setSelectedAmbulanceType}
                contacts={contacts}
                isLoading={isLoading}
                setIsLoading={setIsLoading}
                error={error}
                setError={setError}
              />
            </div>
          </div>
          {/* Right Section - Information Panels */}
          <div className="space-y-6">
            <AmbulanceTypes 
              selectedType={selectedAmbulanceType}
              onTypeSelect={setSelectedAmbulanceType}
            />
            <EmergencyContacts contacts={contacts} />
          </div>
        </div>
        {/* Additional Demo Information */}
        <div className="mt-12 bg-gray-50 rounded-lg p-6">
          <h3 className="text-lg font-semibold text-gray-900 mb-4">🔧 Technical Implementation</h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div>
              <h4 className="font-medium text-gray-900 mb-2">Backend Features</h4>
              <ul className="text-sm text-gray-600 space-y-1">
                <li>• RESTful API with Express.js</li>
                <li>• WebSocket integration with Socket.IO</li>
                <li>• Real-time status updates</li>
                <li>• Live location tracking</li>
                <li>• Smart ambulance matching</li>
                <li>• Emergency priority handling</li>
              </ul>
            </div>
            <div>
              <h4 className="font-medium text-gray-900 mb-2">Frontend Features</h4>
              <ul className="text-sm text-gray-600 space-y-1">
                <li>• React.js with modern hooks</li>
                <li>• Real-time WebSocket client</li>
                <li>• Live tracking component</li>
                <li>• Responsive design</li>
                <li>• Error handling and loading states</li>
                <li>• Pagination and filtering</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
export default AmbulanceDemo
